/* MapleWeld - Request Quotation
 * Modal control, live variant/quantity capture, AJAX submit with
 * graceful fallback to native POST. No jQuery, no theme dependencies.
 */
(function () {
  'use strict';

  var modal = document.querySelector('[data-mw-quote]');
  if (!modal || modal.getAttribute('data-mw-quote-ready') === '1') return;
  modal.setAttribute('data-mw-quote-ready', '1');

  var form           = modal.querySelector('[data-mw-quote-form]') || modal.querySelector('.mw-quote__form');
  var okAlert        = modal.querySelector('[data-mw-quote-ok]');
  var errAlert       = modal.querySelector('[data-mw-quote-error]');
  var submitBtn      = modal.querySelector('[data-mw-quote-submit]');
  var metaLine       = modal.querySelector('[data-mw-quote-meta]');
  var variantSelect  = modal.querySelector('[data-mw-field="variant-select"]');
  var qtyRequired    = modal.querySelector('[data-mw-field="qty-required"]');
  var notUrgent      = modal.querySelector('[data-mw-field="not-urgent"]');
  var requiredBy     = modal.querySelector('[data-mw-field="required-by"]');
  var urgencyField   = modal.querySelector('[data-mw-field="urgency"]');
  var lastFocus      = null;

  function field(key) { return modal.querySelector('[data-mw-field="' + key + '"]'); }

  /* ---------------- product context ---------------- */

  var productData = null;
  var jsonEl = document.querySelector('script[id^="ProductJson-"]');
  if (jsonEl) {
    try { productData = JSON.parse(jsonEl.textContent); } catch (e) { productData = null; }
  }

  function cartForm() {
    return document.querySelector('form[action*="/cart/add"]');
  }

  function selectedVariantId() {
    /* kt_psgl_form.liquid renders this select in every layout. */
    var sel = document.querySelector('select[id^="ProductSelect-"]');
    if (sel && sel.value) return String(sel.value);
    var cf = cartForm();
    var input = cf && cf.querySelector('[name="id"]');
    return input && input.value ? String(input.value) : '';
  }

  function selectedQuantity() {
    var cf = cartForm();
    var qty = cf && cf.querySelector('[name="quantity"]');
    var val = qty ? parseInt(qty.value, 10) : NaN;
    return (isNaN(val) || val < 1) ? 1 : val;
  }

  /* Applies one <option> from the in-modal variant dropdown to the hidden
     id/sku fields and the header meta line. Shared by syncContext() (page
     -> modal) and the dropdown's own change handler (customer picks a
     different variant than the one selected on the page). */
  function applyVariantOption(opt) {
    if (!opt) return;
    var idField = field('variant-id');
    var skuField = field('sku');
    if (idField) idField.value = opt.getAttribute('data-variant-id') || '';
    if (skuField) skuField.value = opt.getAttribute('data-sku') || '';

    if (metaLine) {
      var bits = [];
      var sku = opt.getAttribute('data-sku');
      if (sku) bits.push('SKU ' + sku);
      if (opt.value && opt.value !== 'Default Title') bits.push(opt.value);
      metaLine.textContent = bits.join(' · ');
    }
  }

  function syncContext() {
    var qtyField = field('page-quantity');
    var pageQty = selectedQuantity();
    if (qtyField) qtyField.value = pageQty;

    /* Suggest the page quantity as a starting point, without overwriting
       anything the customer has already typed. */
    if (qtyRequired && qtyRequired.value.trim() === '') {
      qtyRequired.value = String(pageQty);
    }

    var vid = selectedVariantId();
    if (!vid) return;

    if (variantSelect) {
      for (var i = 0; i < variantSelect.options.length; i++) {
        if (variantSelect.options[i].getAttribute('data-variant-id') === vid) {
          if (variantSelect.selectedIndex !== i) variantSelect.selectedIndex = i;
          applyVariantOption(variantSelect.options[i]);
          break;
        }
      }
      return;
    }

    /* Single-variant product: no dropdown, just keep the hidden id in sync. */
    var idField = field('variant-id');
    if (idField) idField.value = vid;

    if (!productData || !productData.variants) return;
    var match = null;
    for (var j = 0; j < productData.variants.length; j++) {
      if (String(productData.variants[j].id) === vid) { match = productData.variants[j]; break; }
    }
    if (!match) return;
    var skuField = field('sku');
    if (skuField) skuField.value = match.sku || '';
    if (metaLine) {
      var bits2 = [];
      if (match.sku) bits2.push('SKU ' + match.sku);
      metaLine.textContent = bits2.join(' · ');
    }
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      applyVariantOption(variantSelect.options[variantSelect.selectedIndex]);
    });
  }

  /* ---------------- required-by / not-urgent ---------------- */

  if (notUrgent && requiredBy) {
    notUrgent.addEventListener('change', function () {
      if (notUrgent.checked) {
        requiredBy.required = false;
        requiredBy.disabled = true;
        requiredBy.value = '';
        if (urgencyField) urgencyField.value = 'Not urgent - no specific deadline';
      } else {
        requiredBy.required = true;
        requiredBy.disabled = false;
        if (urgencyField) urgencyField.value = '';
      }
    });
  }

  /* ---------------- open / close ---------------- */

  function open() {
    syncContext();
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('mw-quote-open');
    var first = modal.querySelector('[data-mw-field="name"]');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
  }

  function close() {
    modal.hidden = true;
    document.body.classList.remove('mw-quote-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-mw-quote-open]')) { e.preventDefault(); open(); return; }
    var c = e.target.closest('[data-mw-quote-close]');
    if (c && modal.contains(c)) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) close();
  });

  /* Variant changes happen on the shared select and on swatch clicks. */
  document.addEventListener('change', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('form[action*="/cart/add"]')) syncContext();
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('.entry-buttons, .product-form__item, .swatch, .kt_swatch')) {
      setTimeout(syncContext, 60);
    }
  });

  syncContext();

  /* ---------------- submit ---------------- */

  if (form) {
    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return; /* native submit */
      e.preventDefault();

      syncContext();
      if (errAlert) errAlert.hidden = true;
      if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.label = submitBtn.textContent; submitBtn.textContent = 'Sending…'; }

      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'text/html' },
        credentials: 'same-origin'
      })
      .then(function (res) {
        var ok = res.ok && res.url && res.url.indexOf('contact_posted=true') !== -1;
        if (!ok) throw new Error('unconfirmed');
        form.hidden = true;
        if (okAlert) okAlert.hidden = false;
      })
      .catch(function () {
        /* Anything unexpected: hand back to the browser so the lead is not lost. */
        if (submitBtn) { submitBtn.disabled = false; if (submitBtn.dataset.label) submitBtn.textContent = submitBtn.dataset.label; }
        form.submit();
      });
    });
  }

  /* Native fallback path returns with ?contact_posted=true */
  if (modal.getAttribute('data-mw-quote-posted') === 'true') {
    if (form) form.hidden = true;
    if (okAlert) okAlert.hidden = false;
    open();
  }
})();
